<template>
	<div id="app">
		<myNav />
		<div class="main-containter">
			<router-view />
		</div>
	</div>
</template>

<script>
import myNav from './components/MyNav.vue'
export default {
	components: {
		myNav,
	},
}
</script>
<style lang="scss">
html,
body {
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
}
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	width: 100%;
	height: 100%;
    .main-containter{
        width: 100%;
        height: calc(100% - 80px);
    }
}

#nav {
	padding: 30px;

	a {
		font-weight: bold;
		color: #2c3e50;

		&.router-link-exact-active {
			color: #42b983;
		}
	}
}
</style>
